<syn-header #header>
  <!-- Meta navigation: language, theme, user -->
  <nav slot="meta-navigation" class="flex items-center">
    <app-user-action></app-user-action>
  </nav>

  <nav slot="label" class="flex items-center gap-2 h-full leading-none">
    <span class="font-semibold text-lg whitespace-nowrap"> {{ appName }} </span>
  </nav>
</syn-header>
